import { defineMessages } from 'react-intl'


export default defineMessages({
  back: {
    defaultMessage: 'Back',
    id: 'back-button.back',
  },
})
